import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Link from "@mui/material/Link";
import { downloadDocument } from "../../utils/helpers";

const ViewOtherDocuments = ({ image, title }) => {
	return (
		<Box
			sx={{
				display: "flex",
				border: "1px solid #e2e8f0",
				color: "#1a202c",
				mb: "1.5rem",
				"&:last-child": {
					mb: 0,
				},
				backgroundColor: "#fff",
			}}
		>
			<Box sx={{ padding: "1rem" }}>
				<Typography
					variant="body1"
					sx={{ fontWeight: "bold", textTransform: "capitalize", mb: "1rem" }}
					gutterBottom
				>
					{title}
				</Typography>
				<Stack direction="row" spacing={2}>
					<Button
						variant="outlined"
						onClick={() => downloadDocument(image)}
						component={Link}
						target="_blank"
					>
						download
					</Button>
					<Button
						variant="outlined"
						component={Link}
						href={image}
						target="_blank"
					>
						preview
					</Button>
				</Stack>
			</Box>
		</Box>
	);
};

export default ViewOtherDocuments;
